import { Navigate, Outlet, useLocation } from "react-router-dom";
import { BrandSettingsNav } from "../components/brand/BrandSettingsNav";
import { useBrandPageContext } from "./BrandLayout";

export function BrandSettingsLayout() {
  const context = useBrandPageContext();
  const { brand } = context;
  const location = useLocation();
  const isVoiceRoute = /\/settings\/voice\/?$/.test(location.pathname);

  if (!brand) {
    return <Navigate to="/brand" replace />;
  }

  return (
    <div>
      <div className="grid gap-4 md:grid-cols-[240px_minmax(0,1fr)] md:items-start">
        <div className="md:sticky md:top-4">
          <BrandSettingsNav />
        </div>
        {isVoiceRoute
          ? (
            <div className="min-w-0">
              <Outlet context={context} />
            </div>
          )
          : (
            <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm md:p-6">
              <Outlet context={context} />
            </div>
          )}
      </div>
    </div>
  );
}
